/**
 *
 * Asynchronously loads the component for Modulistica
 *
 */

import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./index'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./app/containers/Modulistica/Loadable.js